// ============================================================
//  Import en lot (paste JSON)
// ============================================================

import { useState, type FormEvent } from "react";
import type { QuestionInput } from "../lib/types";

const EXAMPLE = `[
  {
    "texte": "Capitale de la France ?",
    "reponses": ["paris"],
    "niveau": "CM1",
    "matiere": "Géographie",
    "difficulte": 1,
    "emoji": "🇫🇷",
    "indice": "Tour Eiffel"
  },
  {
    "texte": "7 × 8 = ?",
    "reponses": ["56", "cinquante-six"],
    "niveau": "CE2",
    "matiere": "Maths",
    "difficulte": 2
  }
]`;

export function QuestionImport({
  onImport,
  onCancel,
}: {
  onImport: (items: QuestionInput[]) => Promise<void>;
  onCancel: () => void;
}) {
  const [raw, setRaw] = useState(EXAMPLE);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) {
        throw new Error("Le JSON doit être un tableau de questions");
      }
      await onImport(parsed as QuestionInput[]);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal-form modal-form-wide" onClick={(e) => e.stopPropagation()}>
        <h2>📥 Importer des questions (JSON)</h2>
        <p className="modal-hint">
          Colle un tableau JSON. Niveau autorisé : CP, CE1, CE2, CM1, CM2, 6e, 5e.
          Max 500 questions par import.
        </p>
        <form onSubmit={onSubmit}>
          <textarea
            value={raw}
            onChange={(e) => setRaw(e.target.value)}
            rows={18}
            spellCheck={false}
            className="json-input"
          />
          {error && <p className="form-error">✗ {error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={onCancel} className="btn-secondary">Annuler</button>
            <button type="submit" disabled={submitting} className="btn-primary">
              {submitting ? "Import en cours…" : "Importer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
